import React, { useState } from "react";
import '../../../assets/css/Sidebar.css';


const AddStaff = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    mobile: "",
    password: "",
    confirmPassword: "",
    designation: "",
    department: "",
    address: "",
    email: "",
    dob: "",
    file: null,
    education: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, file: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted", formData);
  };

  return (
    <div className="form-container">
      <h4>Staff Information</h4>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input type="text" name="firstName" placeholder="First name*" onChange={handleChange} required />
          <input type="text" name="lastName" placeholder="Last name" onChange={handleChange} />
        </div>
        <div className="form-group">
          <select name="gender" onChange={handleChange} required>
            <option value="">Gender*</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
          <input type="text" name="mobile" placeholder="Mobile*" onChange={handleChange} required />
        </div>
        <div className="form-group">
          <input type="password" name="password" placeholder="Password*" onChange={handleChange} required />
          <input type="password" name="confirmPassword" placeholder="Re-Enter Password*" onChange={handleChange} required />
        </div>
        <div className="form-group">
          <input type="text" name="designation" placeholder="Designation" onChange={handleChange} />
          <input type="text" name="department" placeholder="Select Department*" onChange={handleChange} required />
        </div>
        <textarea name="address" placeholder="Address" onChange={handleChange}></textarea>
        <div className="form-group">
          <input type="email" name="email" placeholder="Email*" onChange={handleChange} required />
          <input type="date" name="dob" placeholder="Date Of Birth*" onChange={handleChange} required />
        </div>
        <div className="form-group file-input">
          <input type="file" onChange={handleFileChange} />
        </div>
        <textarea name="education" placeholder="Education" onChange={handleChange}></textarea>
        <div className="form-actions">
          <button type="submit"><b>Submit</b></button>
          <button type="reset"><b>Cancel</b></button>
        </div>
      </form>
    </div>
  );
};

export default AddStaff;